import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { useLocalStorage, useSessionStorage } from 'primereact/hooks'
import Banner from '../banner2.jpg'; // Certifique-se de que o caminho está correto
import Banner3 from '../banner3.jpg'; // Certifique-se de que o caminho está correto
import { RadioButton } from 'primereact/radiobutton';
import { useNavigate } from 'react-router-dom';  // Importar useNavigate
import Conexao from '../../providers/Conexao'
import InputTextEmail from '../../Componentes/InputTextEmail';
import VisualizadorPDF from '../../Componentes/VisualizadorPDF';
var md5 = require('md5');

const Login = (props) => {

    const [username, setUsername] = useState('');

    const [password, setPassword] = useState('');

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState('');

    const toast = React.useRef(null);

    const [theme, setTheme] = useLocalStorage('mira', 'selectedTheme');

    const [tipoAcesso, setTipoAcesso]= useState('cliente');

    const navigate = useNavigate();  // Hook para navegação

    //compras.bru.ebas@ebara.com

    React.useEffect(() => {
        const link = document.getElementById('theme-link');

        if (link) {
            link.href = `/styles/${theme}.css`;
           
        }

    }, [theme]);

    React.useEffect(() => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('habilitarcollector');
        sessionStorage.removeItem('habilitarinventory');
        sessionStorage.removeItem('BarenToken');
        sessionStorage.removeItem('empresas');
        sessionStorage.removeItem('dataEmpresa')
        sessionStorage.removeItem('equipamentos')
        sessionStorage.removeItem('timeUltimaLeitura')
    }, []);

    const handleLogin = () => {

        setLoading(true);
        
        setError('');

        if (!username || !password) {
            setLoading(false);
            setError('Por favor, preencha ambos os campos!');
            toast.current.show({ severity: 'warn', summary: 'Campos obrigatórios', detail: 'Usuário e senha são obrigatórios!' });
            return;
        }

        if(tipoAcesso === 'revenda'){
            autenticarRevenda()
        }else{
            autenticarCliente()
        }
       
    };


    const autenticarRevenda = () =>{
    
        setLoading(true)
        sessionStorage.removeItem('equipamentos');
        sessionStorage.removeItem('timeUltimaLeitura');
    
        Conexao.post('usuariosController/auth', {
            login : username, 
            senha : md5(password)
        }).then(response =>{
          
                if(response.data.status == 'OK'){
                   
                    sessionStorage.setItem('token', md5('datacount#2025'));
                    sessionStorage.setItem('habilitarcollector', response.data.payload.habilitarcollector);
                    sessionStorage.setItem('habilitarinventory', response.data.payload.habilitarinventory	);
                    sessionStorage.setItem('BarenToken', response.data.payload.BarenToken);
                    sessionStorage.setItem('empresas', JSON.stringify(response.data.payload));
                    sessionStorage.setItem('dataEmpresa', JSON.stringify({
                        idrevenda : response.data.payload.empresaPadrao.idrevenda,
                        revenda : response.data.payload.nome,
                        idempresa : response.data.payload.empresaPadrao.idempresa, 
                        empresa : response.data.payload.empresaPadrao.razaosocial, 
                        cnpj : response.data.payload.empresaPadrao.cnpj, 
                        idcliente: null, 
                        cliente : null,
                        latitude : response.data.payload.empresaPadrao.latitude,
                        longitude : response.data.payload.empresaPadrao.longitude,
                        raio : response.data.payload.empresaPadrao.raio,
                        bloqueiofinanceiro : response.data.payload.empresaPadrao.idempresa !== 81 ? response.data.payload.empresaPadrao.bloqueiofinanceiro : 'f',
                    }));
                    

                    navigate('/home', {
                        state: {
                            userName : username, 
                            tipoAcesso : 'REVENDA',                             
                            dataEmpresa : {
                                idrevenda : response.data.payload.empresaPadrao.idrevenda,
                                revenda : response.data.payload.nome,
                                idempresa : response.data.payload.empresaPadrao.idempresa, 
                                empresa : response.data.payload.empresaPadrao.razaosocial, 
                                cnpj : response.data.payload.empresaPadrao.cnpj, 
                                idcliente: null, 
                                cliente : null, 
                                latitude : response.data.payload.empresaPadrao.latitude,
                                longitude : response.data.payload.empresaPadrao.longitude,
                                raio : response.data.payload.empresaPadrao.raio,
                                bloqueiofinanceiro : response.data.payload.empresaPadrao.idempresa !== 81 ? response.data.payload.empresaPadrao.bloqueiofinanceiro : 'f',
                            },
                            empresaPadrao : response.data.payload.empresaPadrao, 
                            dataBase : props.dataBase, 
                            habilitarcollector	: response.data.payload.habilitarcollector, 	
                            habilitarinventory	: response.data.payload.habilitarinventory, 
                        }
                      });
                }else{
                    toast.current.show({ severity: 'warn', summary: 'Erro de login', detail: 'Usuário ou senha incorretos!' });
                }
                setLoading(false)
            
        }).catch( error =>{
            
            toast.current.show({ severity: 'error', summary: 'Erro ao conectar servidor remoto', detail: 'Usuário ou senha incorretos!' });
              setLoading(false)
        })
    }


    const autenticarCliente = () =>{
        setLoading(true)
        sessionStorage.removeItem('equipamentos');
        sessionStorage.removeItem('timeUltimaLeitura');
       
        Conexao.post('clientesController/authCliente', {
            login : username, 
            senha : md5(password)
        }).then(response =>{
          
                if(response.data.status == 'OK'){
                   
                    sessionStorage.setItem('token', md5('datacount#2025'));
                    sessionStorage.setItem('empresas', null);
                    sessionStorage.setItem('BarenToken', response.data.payload.BarenToken);
                    sessionStorage.setItem('dataEmpresa', JSON.stringify({
                        idrevenda : response.data.payload.idusuario,
                        revenda :response.data.payload.nomeempresa , 
                        idempresa : response.data.payload.idempresa, 
                        empresa : response.data.payload.nomeempresa, 
                        idcliente: response.data.payload.idcliente, 
                        cliente : response.data.payload.razaosocial,
                        bloqueiofinanceiro : response.data.payload.bloqueiofinanceiro,
                        
                    }));
                    navigate('/home', {
                        state: {
                            userName : username, 
                            tipoAcesso : 'CLIENTE',
                            empresa : response.data.payload.empresaPadrao,                           
                            dataEmpresa : {
                                idrevenda : response.data.payload.idusuario,
                                revenda :response.data.payload.nomeempresa , 
                                idempresa : response.data.payload.idempresa, 
                                empresa : response.data.payload.nomeempresa, 
                                idcliente: response.data.payload.idcliente, 
                                cliente : response.data.payload.razaosocial,
                                bloqueiofinanceiro : response.data.payload.bloqueiofinanceiro,
                                
                            },
                            dataBase : props.dataBase, 
                            habilitarcollector	: response.data.payload.habilitarcollector, 	
                            habilitarinventory	: response.data.payload.habilitarinventory, 
                        }
                      });
                }else{
                    toast.current.show({ severity: 'warn', summary: 'Erro de login', detail: 'Usuário ou senha incorretos!' });
                }
                setLoading(false)
            
        }).catch( error =>{
            console.log(error)
            toast.current.show({ severity: 'error', summary: 'Erro ao conectar servidor remoto', detail: 'Usuário ou senha incorretos!' });
              setLoading(false)
        })
    }

    return (
        <div
            className="min-h-screen flex justify-content-center align-items-center"
            style={{
                backgroundImage: `url(${Banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
                position: 'relative',
            }}
        >
            
            {/* Sobreposição com fundo azul escuro transparente */}
            <div 
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'fixed',
                    backgroundImage: `url(${Banner3})`,
                    zIndex: 0,
                    opacity : 0.5
                }}
            ></div>

            {/* Card de Login */}
            <Card
                className="w-50 p-4"
                style={{
                    boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
                    zIndex: 1,
                    borderRadius: '10px',
                    padding: '2rem',
                    paddingTop : '1rem',
                    position: 'relative',
                    width : '450px'
                }}
            >
                {/* Texto "Bem Vindo ao DATACOUNT" */}
                <div style={{ textAlign: 'center',  }}>
                    <h3 style={{ fontSize: '1.5rem', marginBottom: '-1.0rem' }}>Bem Vindo ao</h3>
                    <h2 style={{ fontSize: '2rem', fontWeight: 'bold' }}>DATACOUNT</h2>
                </div>

                <div className="p-fluid">
                    <div className="p-field mb-3">
                        <label htmlFor="accessType">Acessar como</label>
                        <div id="accessType">
                            <div className="p-field-radiobutton p-mb-2" style ={{paddingTop : '5px'}}>
                                <RadioButton
                                    inputId="cliente"
                                    name="accessType"
                                    value="cliente"
                                    style={{cursor : 'pointer'}}
                                    onChange={(e) => setTipoAcesso(e.value)}  // Armazena o valor selecionado
                                    checked={tipoAcesso === 'cliente'}  // Marca o radio button se o valor for "cliente"
                                />
                                <label htmlFor="cliente"> Cliente</label>
                            </div>
                            <div className="p-field-radiobutton p-mb-2 " style ={{paddingTop : '5px'}}>
                                <RadioButton
                                    inputId="revenda"
                                    name="accessType"
                                    value="revenda"
                                    style={{cursor : 'pointer'}}
                                    onChange={(e) => setTipoAcesso(e.value)}  // Armazena o valor selecionado
                                    checked={tipoAcesso === 'revenda'}  // Marca o radio button se o valor for "revenda"
                                />
                                <label htmlFor="revenda"> Revenda</label>
                            </div>
                        </div>
                        {error && !tipoAcesso && (
                            <small className="p-error">O campo de tipo de acesso é obrigatório.</small>
                        )}
                    </div>

                    <div className="p-field mb-3">
                        <label htmlFor="username">Usuário</label>
                        <InputTextEmail
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Digite seu usuário"
                            required
                            className={error && !username ? 'p-invalid' : ''}
                        />
                    </div>
                    <div className="p-field mb-3">
                        <label htmlFor="password">Senha</label>
                        <Password
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Digite sua senha"
                            toggleMask
                            required
                            feedback={false}
                            className={error && !password ? 'p-invalid' : ''}
                        />
                    </div>
                    {error && <small className="p-error mb-3">{error}</small>}
                    
                    <Button
                        label="Entrar"r
                        icon="pi pi-sign-in"
                        onClick={handleLogin}
                        loading={loading}
                        disabled={loading}
                        className="w-full"
                        style={{marginTop : '10px'}}
                    />

                    {/* Links "Esqueci a senha" e "Termo de Privacidade" */}
                    <div className="flex justify-content-between mt-3">
                        <a href="/recuperar-senha" style={{ fontSize: '0.9rem', color: '#007ad9', textDecoration: 'none' }} onMouseOver={(e) => e.target.style.textDecoration = 'underline'} onMouseOut={(e) => e.target.style.textDecoration = 'none'}>
                            Esqueci a senha
                        </a>
                        

                        <VisualizadorPDF 
                            arquivo="https://datacount.com.br/downloads/datacountV3.pdf"  
                        />
                    </div>
                    <div style={{textAlign:'center', width :'100%', padding : '10px'}}>
                    <span className="p-field" style={{fontSize : '9px', color:'#ccc'}}>® 2025 - Printerconnect</span>
                    </div>
                     <a href ={'downloads/databit-collector-setup-dbh.zip' } attribute>
                        <span variant='outlined' color='secondary' style={{textAlign: 'center'}}>Download DCA</span>
                    </a>
                </div>
                <Toast ref={toast} />
            </Card>
        </div>
    );
};


export default Login;
